<div class="profile__wrapper">
  <form [formGroup]="salaryRecruiterForm">
    <i
      *ngIf="!isCreate"
      class="icon-pencil"
      [class.grey]="isEditable"
      (click)="switchEdit($event)"
    ></i>
    <fieldset class="form__fieldset" [disabled]="!isEditable">
      <div class="form_wrapper d-flex justify-content-start align-items-center">
        <div
          class="form__input d-flex align-items-center"
          *ngIf="!isNotEmployee"
        >
          <label
            for="salary"
            class="label-input"
            appMarkAsterisk
            [formGroup]="salaryRecruiterForm"
            [controlName]="'salary'"
            [touched]="salaryRecruiterForm.get('salary')!.touched"
            >Start salary (USD gross)
          </label>
          <div class="input__wrapper general_form_input">
            <input
              id="salary"
              placeholder=" "
              class="input__basic input-width"
              type="number"
              formControlName="salary"
            />
            <app-error-field
              [displayError]="
                isFieldInvalid('salary', salaryRecruiterForm) &&
                salaryRecruiterForm.get('salary')!.hasError('required')
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="
                salaryRecruiterForm.get('salary')!.hasError('min')
              "
              [errorMessage]="
                isNotEmployee
                  ? 'The value should be positive'
                  : 'The value should be greater than 0'
              "
            ></app-error-field>
            <app-error-field
              [displayError]="
                salaryRecruiterForm.get('salary')!.hasError('max')
              "
              [errorMessage]="'Max value = 999999'"
            ></app-error-field>
          </div>
        </div>
        <div class="form__input d-flex align-items-center">
          <label
            for="ratePerHour"
            class="label-input"
            appMarkAsterisk
            [formGroup]="salaryRecruiterForm"
            [controlName]="'ratePerHour'"
            [touched]="salaryRecruiterForm.get('ratePerHour')!.touched"
            >Rate per hour
          </label>
          <div class="input__wrapper general_form_input">
            <input
              id="ratePerHour"
              placeholder=" "
              class="input__basic input-width"
              type="number"
              formControlName="ratePerHour"
            />
            <app-error-field
              [displayError]="
                salaryRecruiterForm.get('ratePerHour')!.hasError('max')
              "
              [errorMessage]="'Max value = 999'"
            ></app-error-field>
            <app-error-field
              [displayError]="
                salaryRecruiterForm.get('ratePerHour')!.hasError('min')
              "
              [errorMessage]="
                isNotEmployee
                  ? 'The value should be greater than 0'
                  : 'The value should be positive'
              "
            ></app-error-field>
          </div>
        </div>
      </div>
      <div class="form__textarea" class="label-input">
        <label
          for="comment"
          appMarkAsterisk
          [formGroup]="salaryRecruiterForm"
          [controlName]="'comment'"
          [touched]="salaryRecruiterForm.get('comment')!.touched"
          >Comment</label
        >
        <div class="textarea__wrapper">
          <textarea
            id="comment"
            placeholder=" "
            class="input__textarea"
            formControlName="comment"
          ></textarea>
          <app-error-field
            [displayError]="
              salaryRecruiterForm.get('comment')!.hasError('wordCount')
            "
            [errorMessage]="'Max field length = 400 words'"
          ></app-error-field>
          <ng-container *ngIf="isCreate">
            <img
              *ngIf="!salaryRecruiterForm.controls['dataFile']?.value"
              class="empty_doc icon"
              src="assets/icons/svg/attach_document/none.svg"
              alt="link-empty"
              (click)="inputFile.click()"
            />
            <input
              type="file"
              (change)="handleFileInput($event)"
              accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
              hidden
              #inputFile
            />
            <a [href]="fileSrc" target="_blank"
              ><img
                *ngIf="salaryRecruiterForm.controls['dataFile']?.value"
                class="attached_doc icon"
                src="assets/icons/svg/attached_document/normal.svg"
                alt="link"
            /></a>
            <i
              *ngIf="salaryRecruiterForm.controls['dataFile']?.value"
              class="icon-download-normal icon blue"
              (click)="
                downloadBlobFile(
                  salaryRecruiterForm.get('dataFile')?.value,
                  'data'
                )
              "
            ></i>
            <i
              *ngIf="salaryRecruiterForm.controls['dataFile']?.value"
              class="icon-close icon blue small-close"
              (click)="deleteCommentFile()"
            ></i>
          </ng-container>
        </div>
      </div>
    </fieldset>
  </form>
  <button
    class="button button__save personal__button"
    *ngIf="isEditable"
    (click)="savedData()"
    #saveButton
  >
    Save
  </button>
</div>
